const commonPl = {
    "restaurant": "Restauracja",
    "restaurant_not_found": "Restauracja niedostępna",
    "table_not_available": "Przy tym stole nie można składać zamówień",
    "note": "Notatka",
    "order": "Zamówienie",
    "internal_error": "Żądanie nie powiodło się. Serwer odpowiedział następującym błędem:",
    "no_results": "Brak wyników",
    "cancel": "Anulować",
    "save": "Ratować",
    "back": "Z powrotem",
    "search": "Szukaj",
    "search_for_file_names": "Wyszukaj nazwy plików",
    "delete": "Usuwać",
    "search_by_restaurant": "Szukaj według restauracji",
    "available": "Dostępny",
    "unavailable": "Nie płynny",
    "name": "Nazwa",
    "status": "Status",
    "description": "Opis",
    "price": "Cena",
    "add": "Dodać",
    "phone": "Telefon",
    "internal_server_error": "Wewnętrzny błąd serwera",
    "remove_all": "Wyczyść wszystko",
    "settings": "Ustawienia",
    "restaurant_name": "Nazwa restauracji",
    "reservation_link": "Link do rezerwacji",
    "reservation_link_tooltip": "Dozwolone są wyłącznie linki do systemu rezerwacji Reservours",
    "add_user": "Dodaj użytkownika",
    "add_user_title": "Udziel dostępu do restauracji",
    "restaurant_users": "Użytkownicy mający dostęp do restauracji",
    "restaurant_description_hu": "Opis restauracji (węgierski)",
    "restaurant_description_en": "Opis restauracji (po angielsku)",
    "changes_saved": "Zmiany zostały pomyślnie zapisane",
    "user_added_to_restaurant": "Użytkownikowi przyznano dostęp do restauracji",
    "user_add_to_restaurant_tip": "Użytkownikowi z podanym adresem e-mail zostanie przyznany dostęp do wybranej restauracji. Jeśli użytkownik nie posiada jeszcze konta, dostęp zostanie przyznany automatycznie po rejestracji.",
    "sign_up_here": "Tutaj możesz założyć konto",
    "role_already_exists": "Użytkownik o tym adresie e-mail ma już dostęp do restauracji",
    "error": "Błąd",
    "header_image": "Obraz nagłówka",
    "upload_image": "Prześlij obraz",
    "image_not_set": "Obraz nie został ustawiony",
    "validation": {
        "required": "To pole jest wymagane",
        "optional": "To pole jest opcjonalne"
    },
    "hungary": "Węgry",
    "date": "Data",
    "close": "Zamknąć",
    "continue": "Kontynuować",
    "select_image": "Wybierz obraz",
    "grant": "Dotacja",
    "restaurant_settings": "Ustawienia restauracji",
    "create_restaurant": "Utwórz restaurację",
    "restaurant_created": "Restauracja stworzona pomyślnie",
    "restaurant_created_text": "Twoja restauracja została pomyślnie utworzona. Możesz teraz dodawać pozycje menu i zarządzać ustawieniami restauracji.",
    "continue_to_menu": "Kontynuuj edycję menu",
    "languages": {
        "hu": "węgierski",
        "en": "angielski",
        "de": "niemiecki",
        "fr": "francuski",
        "sk": "słowacki",
        "cz": "czeski",
        "pl": "Polski",
        "si": "słoweński",
        "hr": "chorwacki",
        "ro": "rumuński"
    },
    "no_file_selected": "Nie wybrano pliku",
    "max_file_size": "Maksymalny rozmiar pliku:",
    "language": "Język",
    "google_analytics": "Google Analytics",
    "facebook_pixel": "Piksel Facebooka",
    "analytic_integration_premium_feature": "Integracja analityki jest częścią planu PRO",
    "refresh": "Odświeżać",
    "address": "Adres",
    "city": "Miasto",
    "postal_code": "Kod pocztowy",
    "timezone": "Strefa czasowa",
    "country": "Kraj",
    "currency": "Waluta",
    "currency_tooltip": "Wymagane jest to tylko w przypadku ustawień profilu, nasz system nie będzie wykonywał transakcji finansowych w Twoim imieniu",
    "or": "Lub",
    "datachange_detected": "Wykryto zmianę danych",
    "datachange_subtitle": "Menu, które edytujesz, zostało zmienione od czasu załadowania strony.",
    "datachange_description": "Czy chcesz ponownie załadować menu i utracić zmiany, czy zachować obecną wersję i nadpisać pozostałe zmiany?",
    "datachange_refresh": "Odśwież stronę, stracę moje zmiany",
    "datachange_overwrite": "Zachowaj moją wersję, nadpisz inne zmiany"
};

export default commonPl;
